<template>
    <v-footer
            padless
            fixed
    >
        <v-card
                flat
                tile
                width="100%"
                class="grey lighten-5 text-center"
        >
            <v-row>
                <v-col align="right">
                    <span class="wrapper-left">
                        <v-icon class="mr-2">{{ mdiCart }}</v-icon>
                    </span>
                </v-col>
                <v-divider
                        vertical
                ></v-divider>
                <v-col align="left">
                    <duo-footer-cart :qty="cartItems.qty" :value="cartItems.value"></duo-footer-cart>
                </v-col>
            </v-row>
        </v-card>
    </v-footer>
</template>

<script>
    import duoFooterCart from '../common/duo-footer-cart';
    import { mdiCart } from '@mdi/js';

    export default {
      data() {
          return {
            mdiCart: mdiCart,
          }
      },
      components: {
          'duoFooterCart': duoFooterCart
      },
      props: ['steps', 'cartItems', 'stepPrefix', 'test'],
    }
</script>